import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { environment } from 'src/environments/environment';
import { DocumentModel, DocumentUploadDto } from '../models/requests/DocumentUploadDto';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { TemplateBindingIdentifier } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})

export class DocumentsService {

  constructor(private httpClient: HttpClient) { }


  uploadEmployeeDocument(newContractRequest: DocumentUploadDto): Observable<ApiResponseObject<DocumentUploadDto>> {

    return this.httpClient.post<ApiResponseObject<DocumentUploadDto>>(`${environment.apiUrl}/Documents/UploadEmployyeDocument`, newContractRequest);
  }

  getDocumentsByEmployee(id: number): Observable<ApiResponseObject<DocumentModel[]>> {
    return this.httpClient.get<ApiResponseObject<DocumentModel[]>>(`${environment.apiUrl}/Documents/GetByEmployee/${id}`);
  }
  DownloadDocument(id: number): Observable<ApiResponseObject<DocumentModel[]>> {
    return this.httpClient.get<ApiResponseObject<DocumentModel[]>>(`${environment.apiUrl}/Documents/DownloadDocument/${id}`);

  }

  public DownloadPDF(templateId: string, fileName: string): void {
    
    let DATA: any = document.getElementById(templateId);
    
    html2canvas(DATA, { useCORS: true, allowTaint: true, scrollY: 0 }).then((canvas) => {
      const image = { type: 'jpeg', quality: 0.98 };
      const margin = [0.5, 0.5];

      var imgWidth = 8.5;
      var pageHeight = 11;

      var innerPageWidth = imgWidth - margin[0] * 2;
      var innerPageHeight = pageHeight - margin[1] * 2;

      // Calculate the number of pages.
      var pxFullHeight = canvas.height;
      var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
      var nPages = Math.ceil(pxFullHeight / pxPageHeight);

      // Define pageHeight separately so it can be trimmed on the final page.
      var pageHeight = innerPageHeight;

      // Create a one-page canvas to split up the full image.
      var pageCanvas = document.createElement('canvas');
      var pageCtx = pageCanvas.getContext('2d');
      pageCanvas.width = canvas.width;
      pageCanvas.height = pxPageHeight;

      // Initialize the PDF.
      var pdf = new jsPDF('p', 'in', [8.5, 11]);

      for (var page = 0; page < nPages; page++) {
        // Trim the final page to reduce file size.
        if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
          pageCanvas.height = pxFullHeight % pxPageHeight;
          pageHeight = (pageCanvas.height * innerPageWidth) / pageCanvas.width;
        }

        // Display the page.
        var w = pageCanvas.width;
        var h = pageCanvas.height;
        pageCtx!.fillStyle = 'white';
        pageCtx!.fillRect(0, 0, w, h);
        pageCtx!.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

        // Add the page to the PDF.
        if (page > 0) pdf.addPage();
        ;
        var imgData = pageCanvas.toDataURL('image/' + image.type, image.quality);
        pdf.addImage(imgData, image.type, margin[1], margin[0], innerPageWidth, pageHeight);
      }                                   

      pdf.save(fileName);
    })
  }

}
